module.exports = __webpack_public_path__ + "icon-tw.png?0a39d4ce80a6f9fe69561ffa3d193a24";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-tw.png
// module id = 208
// module chunks = 0